'use strict';

var moduleName = require('./src/angular-input-masks.js');

module.exports = moduleName;



//////////////////
// WEBPACK FOOTER
// ./~/angular-input-masks/index.js
// module id = 573
// module chunks = 1